import React,{Fragment} from "react";
import CloudTelephonyItems from "./CloudTelephonyItems";


class CloudTelephony extends React.Component{

    render(){
        return (
            <Fragment>
                <div className={'mt-3'}>
                    <CloudTelephonyItems/>
                </div>
            </Fragment>
        )
    }
}

export default CloudTelephony;